import React, { useState } from 'react';
import { updateFormData, updateTransformDoc } from 'js/actions';
import { useDispatch } from 'react-redux';
import { DescriptionOutlined } from '@mui/icons-material';
import StyledFixedPanel from 'new/components/StyledFixedPanel/StyledFixedPanel';
import { FORM_TYPE_CREATE_REUSABLE_TX as FormKey } from 'js/constants/formTypes';
import { useGetForm } from 'new/hooks/useGetForm';
import { TransformDataForm } from 'new/components/ReusableTransform/types';
import { useGetTransformDocumentation } from 'new/components/ReusableTransform/ReusableDocumentation/useGetTransformDocumentation';
import ReusableDocEditor from './ReusableDocEditor';

import './ReusableDocumentation.scss';
import { Typography } from '@mui/material';
import { Form } from '@nexla/@types';

type Props = {
  transformID?: number;
};

function ReusableDocumentation({ transformID }: Props) {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch<any>();
  const form = useGetForm<Form<TransformDataForm>>(FormKey);
  const documentation = useGetTransformDocumentation(transformID, [open]);

  const update = (text: string) => {
    setOpen(false);
    if (transformID) {
      dispatch(updateTransformDoc(transformID, text));
    } else {
      const formData = { documentation: text };
      dispatch(updateFormData(FormKey, formData));
    }
  };

  // A NEW transform starts with an empty doc editor (no prefilled scaffold, no
  // placeholder) — same as the flow/nexset doc editors.
  const initialDocumentationText = transformID
    ? documentation?.text
    : form?.data.documentation || '';

  return (
    <>
      <button name="toogle-reusable-documentation" role="button" onClick={() => setOpen((s) => !s)}>
        <span className="title">Documentation</span>
        <div className="icon-box">
          <DescriptionOutlined color="action" />
        </div>
      </button>

      {open ? (
        <div className="attribute-transform-overlay-modal">
          <div className="modal-fader" onClick={() => setOpen(false)} />
          <StyledFixedPanel>
            <div style={{ padding: 'var(--spacing-md)' }}>
              <Typography variant="h3">Documentation</Typography>
              <Typography variant="body2">
                Share the purpose of this Reusable Transform to ensure effective use.
              </Typography>
            </div>

            <ReusableDocEditor
              initialText={initialDocumentationText}
              onSaveDocumentationClick={update}
              onDiscardChangesClick={() => setOpen(false)}
            />
          </StyledFixedPanel>
        </div>
      ) : null}
    </>
  );
}

export default React.memo(ReusableDocumentation);
